<template>
  <div>
    <el-container height="100%">
      <el-header height="80px" >
        医废智能管理系统
      <div style="display: inline-block;float: right;height:30px;line-height:30px;margin-top:25px;margin-right:35px;min-width:80px;font-size: 16px">
        <el-dropdown @command="handleCommand" trigger="click">
          <span class="el-dropdown-link">
            <el-icon class="el-icon-setting"></el-icon>
             {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="modifyPwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="exit">安全退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      </el-header>
      <el-container height="100%">
        <el-aside width="200" align="left">
          <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSelect" :collapse="isCollapse"  :router="true">
            <el-menu-item index="1" :router="false" route="#">
              <i :class="[isCollapse==true ? 'el-icon-s-unfold':'el-icon-s-fold']"></i>
              <span slot="title">{{isCollapse?"展开":"折叠"}}</span>
            </el-menu-item>
            <el-submenu v-for="(m,id) in menus" v-if="((power&m.power)!==0 && m.name!='我的二维码')||  ((power&m.power)!==0 &&!(power>32768 && m.name==='我的二维码'))" :key="id" :index="id+2+''">
              <template slot="title">
              <i :class="m.icon"></i>
              <span slot="title">{{m.name}}</span>
              </template>
              <el-menu-item  v-for="(item,index) in m.items" v-if="((power&item.power)!==0 && (item.name!='我的报表'&&item.name!='我的转运联单')) || ((power&item.power)!==0 &&!(power>32768 && (item.name==='我的报表'||item.name==='我的转运联单')))" :index="id+'_'+index"  :name="id+'_'+index"   :key="index" :to="item.link" :route="item.link" :router="true">
                <span>{{item.name}}</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main height="100%">
            <router-view/>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog title="修改密码" :visible.sync="modifyPwdVisible">
      <el-form :model="form">
        <el-form-item label="旧密码" :label-width="formLabelWidth">
          <el-input v-model="form.oldPwd" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input v-model="form.pwd" autocomplete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" :label-width="formLabelWidth">
          <el-input v-model="form.rePwd" autocomplete="off" show-password clearable ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyPwdVisible = false">取 消</el-button>
        <el-button type="primary" @click="modifyPwd" :loading="modifyPwdSending">修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import coder from "./enum.js"
  import power from "./power.js"
  export default {
    mounted() {
      if (window.ws==undefined||window.ws==null){
        this.$router.push("/");
        return;
      }

      this.userName=window.userName;
      this.role=window.role;
      this.power=window.power;

      console.log("role:::",this.role,this.power);
    },
    name: "mainPage",
    data() {
      return {
        modifyPwdSending:false,
        formLabelWidth:"120px",
        isCollapse: false,
        role:0,
        power:0,
        userName:"未知用户",
        modifyPwdVisible:false,
        form: {
          oldPwd:'',
          pwd:'',
          rePwd:''
        },
        menus:[
          // {
          //   name: "图表(0%)",
          //   icon: "el-icon-s-data",
          //   power:power.DATA_ADMIN,
          //   items: [
          //     {name: "综合视图", link: "/m/wait", power:power.DATA_ADMIN|power.DATA_MANAGER|power.DATA_SELF},
          //     {name: "投放时间分析", link: "/m/wait", power:power.DATA_ADMIN|power.DATA_MANAGER|power.DATA_SELF},
          //     {name: "回收站分析", link: "/m/wait", power:power.DATA_ADMIN|power.DATA_MANAGER|power.DATA_SELF},
          //     {name: "历史走势", link: "/m/wait", power:power.DATA_ADMIN|power.DATA_MANAGER|power.DATA_SELF},
          //   ]
          // },
          {
            name: "预付费管理",
            icon: "el-icon-s-order",
            power:power.MW_ADMIN,
            items: [
              {name: "批量导入充值", link: "/m/BatchImportDeposit", power:power.MW_ADMIN},
              {name: "预存录入", link: "/m/DepositInput", power:power.MW_ADMIN},
              {name: "退款录入", link: "/m/WithdrawalInput", power:power.MW_ADMIN},
              {name: "变更记录", link: "/m/OrderList", power:power.MW_ADMIN},
              {name: "核销", link: "/m/Verification", power:power.MW_ADMIN},
              {name: "核销区县报表", link: "/m/VerificationAreaReport", power:power.MW_ADMIN},
              {name: "核销报表", link: "/m/VerificationReport", power:power.MW_ADMIN},
            ]
          },
          {
            name: "报表管理",
            icon: "el-icon-s-data",
            power:power.MW_ADMIN,
            items: [
              {name: "区县汇总", link: "/m/CountyReport", power:power.MW_ADMIN},
              {name: "区县详情汇总", link: "/m/CountyDetailsReport", power:power.MW_ADMIN},
              {name: "月度汇总报表", link: "/m/MonthReport", power:power.MW_ADMIN},
            ]
          },
          {
            name: "医废管理",

            icon: "el-icon-delete-solid",
            power:power.MW_ADMIN|power.USER_MANAGER|power.USER_SELF,
            items: [
              // {name: "医废查询", link: "/m/wait", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
              {name: "转运联单", link: "/m/Transshipment_sheet", power:power.MW_ADMIN},
              {name: "报表打印", link: "/m/report", power:power.MW_ADMIN},
              {name: "按日统计", link: "/m/StatisticsByDay", power:power.MW_ADMIN},
              {name: "我的报表", link: "/m/myTransport", power:power.USER_MANAGER},
              {name: "我的转运联单", link: "/m/myTransshipmentSheet", power:power.USER_MANAGER},

              // {name: "日报表", link: "/m/wait", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
              // {name: "月报表", link: "/m/wait", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
              // {name: "月汇总表", link: "/m/wait", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
              // {name: "月内日汇总表", link: "/m/wait", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
              // {name: "年报表", link: "/m/wait", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
              // {name: "企业报表", link: "/m/mw_search", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
              // {name: "历史走势", link: "", power:power.MW_ADMIN|power.MW_MANAGER|power.MW_SELF},
            ]
          },
          {
            name:"智能中转柜管理",
            icon:"el-icon-s-shop",
            power:power.TERMINAL_ADMIN|power.TERMINAL_MANAGER|power.TERMINAL_SELF,
            items:[
              {name:"已录入设备",link:"/m/terminal_manager",power:power.TERMINAL_ADMIN|power.TERMINAL_MANAGER|power.TERMINAL_SELF},
              {name:"录入新设备",link:"/m/registerTerminal",power:power.TERMINAL_ADMIN|power.TERMINAL_MANAGER|power.TERMINAL_SELF},
              // {name:"投放时间",link:"/m/terminal_manager",power:power.TERMINAL_ADMIN|power.TERMINAL_MANAGER|power.TERMINAL_SELF},
              // {name:"日志查询",link:"/m/wait",power:power.TERMINAL_ADMIN|power.TERMINAL_MANAGER|power.TERMINAL_SELF},
            ]
          },
          {
            name:"医疗企业管理",
            icon:"el-icon-s-home",
            power:power.COMPANY_ADMIN|power.COMPANY_MANAGER,
            items:[
              {name:"企业管理",link:"/m/company",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER},
              // {name:"投放情况",link:"/m/company",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER},
            ]
          },{
            name:"人员管理",
            icon:"el-icon-s-custom",
            power:power.MW_ADMIN,
            items:[
              {name:"人员管理",link:"/m/user_list",power:power.USER_ADMIN|power.USER_MANAGER|power.USER_SELF},
              // {name:"登陆日志",link:"/m/wait",power:power.USER_ADMIN|power.USER_MANAGER|power.USER_SELF},
            ]
          },{
            name:"地区管理",
            icon:"el-icon-s-help",
            power:power.COMPANY_ADMIN|power.COMPANY_MANAGER,
            items:[
              {name:"地区管理",link:"/m/area",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER},
              // {name:"登陆日志",link:"/m/user_list",power:power.USER_ADMIN|power.USER_MANAGER|power.USER_SELF},
            ]
          },{
            name:"线路管理",
            icon:"el-icon-share",
            power:power.COMPANY_ADMIN|power.COMPANY_MANAGER,
            items:[
              {name:"线路管理",link:"/m/line",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER},
              // {name:"登陆日志",link:"/m/user_list",power:power.USER_ADMIN|power.USER_MANAGER|power.USER_SELF},
            ]
          },
          // {
          //   name:"我的智能中转柜(0%)",
          //   icon:"el-icon-s-flag",
          //   power:power.MW_ADMIN,
          //   items:[
          //     {name:"投放点",link:"/m/wait",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER},
          //     {name:"投放点状态",link:"/m/wait",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER},
          //   ]
          // },
          {
            name:"我的二维码",
            icon:"el-icon-menu",
            power:power.USER_MANAGER|power.USER_SELF,
            items:[
              {name:"二维码打印",link:"/m/qr_printer",power:power.USER_MANAGER|power.USER_SELF},
            ]
          },{
            name:"车辆/驾驶员/押运员",
            icon:"el-icon-menu",
            power:power.USER_ADMIN,
            items:[
              {name:"车辆管理",link:"/m/car_list",power:power.USER_ADMIN},
              {name:"驾驶员/押运员管理",link:"/m/driver_list",power:power.USER_ADMIN},
            ]
          },{
            name:"车辆出入管理",
            icon:"el-icon-s-claim",
            power:power.COMPANY_ADMIN|power.COMPANY_MANAGER|power.GUARD,
            items:[
              {name:"车辆出入",link:"/m/car_out_list",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER|power.GUARD},
              {name:"历史记录",link:"/m/car_out_history",power:power.COMPANY_ADMIN|power.COMPANY_MANAGER|power.GUARD},
            ]
          }
        ]
      };
    },
    methods: {
      modifyPwd(e){
        if (this.form.oldPwd==""){
          this.$alert('请输入旧密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.pwd==""){
          this.$alert('请输入新密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.rePwd==""){
          this.$alert('请再次输入新密码', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.pwd!=this.form.rePwd){
          this.$alert('两次输入的密码不一致，请重新输入！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        if (this.form.pwd==this.form.oldPwd){
          this.$alert('新密码与旧密码相同，请重新输入！', '错误', {
            confirmButtonText: '确定'
          });
          return
        }
        this.modifyPwdSending=true;
        e.target.disabled=true;
        let $this=this;
        window.ws.AddFunc("S2W_ModifyPwdRes",function (code,err) {
          $this.modifyPwdSending=false;
          e.target.disabled=false;
          console.log(code,coder.OK,code==coder.OK);
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            $this.$notify({
              title: '成功',
              message: '密码修改成功',
              type: 'success'
            });
            $this.modifyPwdVisible=false;
          }
        });
        window.ws.Call("W2S_ModifyPwd",this.form.oldPwd,this.form.pwd)
      },
      handleCommand(cmd){
        if (cmd=="modifyPwd"){
          this.from={
            oldPwd:'',
            pwd:'',
            rePwd:''
          };
          this.modifyPwdVisible=true;
        }else{
          window.ws.Close();
        }
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handleSelect(key,keyPath){
        console.log("handleSelect",key,keyPath,window.user);
        if (key==1){
          this.isCollapse=!this.isCollapse;
        }
      },
      beforeRouteEnter (to, from, next){
        console.log("beforeRouteEnter:",to,from,next);
        console.log("beforeRouteEnter:",to,from,next);
      }
    }
  }
</script>

<style scoped>
  .el-header, .el-footer {
    background-color: #4664aa;
    color: #fff;
    font-size: 24px;
    text-align: left;
    line-height: 80px;

  }
  .el-dropdown-link {
    cursor: pointer;
    color: #fdff9f;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .el-aside {
    /*background-color: #D3DCE6;*/
    color: #333;
    /*text-align: center;*/
    /*height: 100%;*/
  }

  /*.el-main {*/
    /*!*background-color: #E9EEF3;*!*/
    /*color: #333;*/
    /*text-align: center;*/
    /*height: 100%;*/
  /*}*/
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
    color: #333;
    background-color: #cdd7e2;

  }
</style>



// WEBPACK FOOTER //
// src/view/main.vue